import { eachDayOfInterval, format, parseISO, subDays } from 'date-fns';
import { floorCalendar } from '../data/floorCalendar';

export type FloorPreset = 'today' | 'yesterday' | 'week' | 'custom';

export interface FloorRange {
  /** Reported days in the range (empty when nothing has been reported yet) */
  dates: string[];
  label: string;
}

const iso = (d: Date) => format(d, 'yyyy-MM-dd');
const short = (date: string) => format(parseISO(date), 'EEE, MMM d');

function span(start: string, end: string): string[] {
  return eachDayOfInterval({ start: parseISO(start), end: parseISO(end) }).map(iso);
}

export function resolveFloorRange(preset: FloorPreset, custom: { start: string; end: string }): FloorRange {
  switch (preset) {
    case 'today':
      return { dates: [], label: `Today, ${short(floorCalendar.today)}` };
    case 'yesterday':
      return { dates: [floorCalendar.max], label: `Yesterday, ${short(floorCalendar.max)}` };
    case 'week': {
      const start = iso(subDays(parseISO(floorCalendar.max), 6));
      return { dates: span(start, floorCalendar.max), label: `This week, ${format(parseISO(start), 'MMM d')} – ${format(parseISO(floorCalendar.max), 'MMM d')}` };
    }
    default: {
      const clamp = (d: string) => (d < floorCalendar.min ? floorCalendar.min : d > floorCalendar.max ? floorCalendar.max : d);
      const a = clamp(custom.start);
      const b = clamp(custom.end);
      const [start, end] = a <= b ? [a, b] : [b, a];
      return {
        dates: span(start, end),
        label: start === end ? short(start) : `${format(parseISO(start), 'MMM d')} – ${format(parseISO(end), 'MMM d')}`,
      };
    }
  }
}
